import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import httpClient from '../../../http/HttpRequest';
import {useParams } from 'react-router-dom';
import { COMPANY_DETAILS, GET_PAYMENT_DETAILS } from '../../../data/url';
import InvoiceHeader from '../layout/invoice/InvoiceHeader';
import InvoiceAddress from '../layout/invoice/InvoiceAddress';
import Helper from '../../../helper/Helper';
import { generatePDF } from '../../pdf/GeneratePDF';

export default function ViewPayment() {

     const [payment, setPayment] = useState({});
     const [company, setCompanyDetails] = useState({});
     const [customer, setCustomer] = useState({});
     const [paymentDetails, setPaymentDetails] = useState([]);
     const { t } = useTranslation();

     const { id } = useParams();

     const headers = ['s_no', 'document_number', 'date', 'amount', 'payment_amount'];
     const thStyle = { padding: "9px", verticalAlign: "center", fontSize: "12px" };

     const componentRef = React.useRef();

     const handlePrint = useReactToPrint({
          content: () => componentRef.current,
     });

     useEffect(() => {
          getPaymentDetails();
          getCompanyDetails();
     }, []);


     const getPaymentDetails = async (e) => {
          const res = await httpClient.post(GET_PAYMENT_DETAILS, { id: id });
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setPayment(result.data.paymet_details);
                    setCustomer(result.data.customer);
                    setPaymentDetails(result.data.payment);
               }
          }
     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setCompanyDetails(result.data);

               }
          };
     }

     const makePdf = () => {
          let filename = `${payment.number}-PAYMENT`;
          generatePDF(filename); 
     };

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="view_payment" subTitle="payment" subTitleLink="root/payment" />
                    <div className="card col-md-11 m-auto" id="payment">
                         <div className="card-body" id="print_section" ref={componentRef}>
                              <InvoiceHeader title="payment_receipt" number={`${payment.prefix}-${payment.number}`} />
                              <InvoiceAddress title="payment_receipt" customer={customer} company={company} order={payment} />

                              <table className="text-center table table-striped table-hover">
                                   <thead className='bg-primary text-white '>
                                        <tr className=''>
                                             {headers.map((header, index) => (
                                                  <th style={thStyle} key={index}>{t(header)}</th>
                                             ))}
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {
                                             paymentDetails.map((p, index) => (
                                                  <tr key={`view-payment-${index}`}>
                                                       <td>{index + 1}</td>
                                                       <td>{p.number}{p.bill_number}</td>
                                                       <td>{p.invoice_date}{p.bill_date}</td>
                                                       <td> {p.net_amount > 0 ? Helper.formatNumber(p.net_amount) : Helper.formatNumber(p.bill_amount) } </td>
                                                       <td>{Helper.formatNumber(p.amount)}</td>
                                                  </tr>
                                             ))
                                        }
                                   </tbody>
                              </table>
                              <div className='mt-3'>
                                   {t('notes')} : {payment.notes}
                              </div>
                              <hr />
                         </div>
                         <div className='text-center'>
                              <button className="btn btn-sm btn-danger btn-icon-text m-1" onClick={makePdf}>{t('pdf')}</button>
                              <button className="btn btn-sm btn-info m-1" onClick={handlePrint}>{t('print')}</button>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
